import React from "react";
import BookDetails from "layouts/book/components/book-details";

const NewBook = () => <BookDetails />;

export default NewBook;
